import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";

export default createRemoteArrayResourceReducer("ESCALATED_REPORTS");
